export const LOGIN_REDIRECT_LINK = "/auth/";

export const APP_NAME = "Altar";
